module.exports = __webpack_public_path__ + "static/img/typograph@w.91df7cd.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/discover/typograph@w.gif
// module id = 3LdN
// module chunks = 0